import { OperatorJourney } from '../components/investor/OperatorJourney';

export default function OperatorInvestorPage({ onJoin }) {
  return <OperatorJourney onJoin={onJoin} />;
}